import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Effect from 'effect/Effect';
import { pipe } from 'effect/Function';
import { ApiClient } from '@/api/client';
import { CategoryResponseSchema } from '@/api/schemas/category.schema';
import { MainLayer } from '@/effects/layers';
import { QUERY_KEYS } from '@/lib/constants';
import { toast } from 'sonner';

export function useToggleCategoryPin() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ categoryId }: { categoryId: string }) => {
      const program = pipe(
        ApiClient,
        Effect.flatMap((client) =>
          client.put(
            `/categories/${categoryId}/toggle-pin`,
            {},
            CategoryResponseSchema
          )
        ),
        Effect.provide(MainLayer)
      );

      return Effect.runPromise(program);
    },
    onSuccess: (data) => {
      // Invalidate categories queries to refresh the list
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CATEGORIES] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GROUP_CATEGORIES] });

      // Show success message
      const isPinned = data.category.pinned;
      toast.success(
        isPinned
          ? `Pinned ${data.category.name}`
          : `Unpinned ${data.category.name}`
      );
    },
    onError: (error) => {
      console.error('Failed to toggle category pin:', error);
      toast.error('Failed to update category');
    },
  });
}